"use strict";

var _regeneratorRuntime = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuctionHouse = void 0;

var tslib_1 = require("tslib");

var ethers_1 = require("ethers");

var typechain_1 = require("@zoralabs/auction-house/dist/typechain");

var _4_json_1 = tslib_1.__importDefault(require("@zoralabs/auction-house/dist/addresses/4.json"));

var _1_json_1 = tslib_1.__importDefault(require("@zoralabs/auction-house/dist/addresses/1.json"));

var _137_json_1 = tslib_1.__importDefault(require("@zoralabs/auction-house/dist/addresses/137.json"));

var _80001_json_1 = tslib_1.__importDefault(require("@zoralabs/auction-house/dist/addresses/80001.json"));

var addresses_1 = require("./addresses");

var utils_1 = require("./utils");

var auctionHouseAddresses = {
  rinkeby: _4_json_1.default.auctionHouse,
  mainnet: _1_json_1.default.auctionHouse,
  polygon: _137_json_1.default.auctionHouse,
  polygonMumbai: _80001_json_1.default.auctionHouse
};

var AuctionHouse = /*#__PURE__*/function () {
  function AuctionHouse(signerOrProvider, chainId) {
    _classCallCheck(this, AuctionHouse);

    this.chainId = chainId;
    this.readOnly = !ethers_1.Signer.isSigner(signerOrProvider);
    this.signerOrProvider = signerOrProvider;
    var network = utils_1.chainIdToNetworkName(chainId);
    var address = auctionHouseAddresses[network];
    this.auctionHouse = typechain_1.AuctionHouse__factory.connect(address, signerOrProvider);
    this.zoraAddress = addresses_1.addresses[network].media;
  }

  _createClass(AuctionHouse, [{
    key: "fetchAuction",
    value: function () {
      var _fetchAuction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(auctionId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.auctionHouse.auctions(auctionId));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchAuction(_x) {
        return _fetchAuction.apply(this, arguments);
      }

      return fetchAuction;
    }()
  }, {
    key: "fetchAuctionFromTransactionReceipt",
    value: function () {
      var _fetchAuctionFromTransactionReceipt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(receipt) {
        var _iterator, _step, log, description;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iterator = _createForOfIteratorHelper(receipt.logs);
                _context2.prev = 1;

                _iterator.s();

              case 3:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 10;
                  break;
                }

                log = _step.value;
                description = this.auctionHouse.interface.parseLog(log);

                if (!(description.args.auctionId && log.address === this.auctionHouse.address)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", this.fetchAuction(description.args.auctionId));

              case 8:
                _context2.next = 3;
                break;

              case 10:
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](1);

                _iterator.e(_context2.t0);

              case 15:
                _context2.prev = 15;

                _iterator.f();

                return _context2.finish(15);

              case 18:
                return _context2.abrupt("return", null);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 12, 15, 18]]);
      }));

      function fetchAuctionFromTransactionReceipt(_x2) {
        return _fetchAuctionFromTransactionReceipt.apply(this, arguments);
      }

      return fetchAuctionFromTransactionReceipt;
    }()
  }, {
    key: "createAuction",
    value: function () {
      var _createAuction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(tokenId, duration, reservePrice, curator, curatorFeePercentages, auctionCurrency) {
        var tokenAddress,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tokenAddress = _args3.length > 6 && _args3[6] !== undefined ? _args3[6] : this.zoraAddress;
                return _context3.abrupt("return", this.auctionHouse.createAuction(tokenId, tokenAddress, duration, reservePrice, curator, curatorFeePercentages, auctionCurrency));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createAuction(_x3, _x4, _x5, _x6, _x7, _x8) {
        return _createAuction.apply(this, arguments);
      }

      return createAuction;
    }()
  }, {
    key: "setAuctionApproval",
    value: function () {
      var _setAuctionApproval = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(auctionId, approved) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.auctionHouse.setAuctionApproval(auctionId, approved));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function setAuctionApproval(_x9, _x10) {
        return _setAuctionApproval.apply(this, arguments);
      }

      return setAuctionApproval;
    }()
  }, {
    key: "setAuctionReservePrice",
    value: function () {
      var _setAuctionReservePrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(auctionId, reservePrice) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.auctionHouse.setAuctionReservePrice(auctionId, reservePrice));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setAuctionReservePrice(_x11, _x12) {
        return _setAuctionReservePrice.apply(this, arguments);
      }

      return setAuctionReservePrice;
    }()
  }, {
    key: "createBid",
    value: function () {
      var _createBid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(auctionId, amount) {
        var _yield$this$auctionHo, auctionCurrency;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.auctionHouse.auctions(auctionId);

              case 2:
                _yield$this$auctionHo = _context6.sent;
                auctionCurrency = _yield$this$auctionHo.auctionCurrency;

                if (!(auctionCurrency === ethers_1.ethers.constants.AddressZero)) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt("return", this.auctionHouse.createBid(auctionId, amount, {
                  value: amount
                }));

              case 8:
                return _context6.abrupt("return", this.auctionHouse.createBid(auctionId, amount));

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createBid(_x13, _x14) {
        return _createBid.apply(this, arguments);
      }

      return createBid;
    }()
  }, {
    key: "endAuction",
    value: function () {
      var _endAuction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(auctionId) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.auctionHouse.endAuction(auctionId));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function endAuction(_x15) {
        return _endAuction.apply(this, arguments);
      }

      return endAuction;
    }()
  }, {
    key: "cancelAuction",
    value: function () {
      var _cancelAuction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(auctionId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.auctionHouse.cancelAuction(auctionId));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function cancelAuction(_x16) {
        return _cancelAuction.apply(this, arguments);
      }

      return cancelAuction;
    }()
  }]);

  return AuctionHouse;
}();

exports.AuctionHouse = AuctionHouse;